import { quoteOrTabRemoved } from 'epic/workspace/common/tabs/tabsEpics/quoteOrTabRemoved';
import type { ProductGovernance } from 'models/streaming';
import { ofType } from 'redux-observable';
import type { SchedulerLike } from 'rxjs';
import { EMPTY, of } from 'rxjs';
import { catchError, filter, map, mergeMap, take, takeUntil, timeoutWith } from 'rxjs/operators';
import {
  productGovernanceAssessmentReceived,
  productGovernanceAssessmentTimeout,
} from 'state/quotes/regulations/regulation.actions';
import { isQuoteTypeWithRegulation } from 'state/quotes/utils';
import type { EpicWithThunk } from 'state/state.common';
import { fatEventApiConnector } from 'utils/streaming/api';
import { productGovernanceAssessment } from 'utils/streaming/messages';

// TODO catch Error in Epic
export function productGovernanceAssessmentEpic(appScheduler?: SchedulerLike): EpicWithThunk {
  return (action$, state$, { oldHttpClient, getSgmeConfiguration, streaming }) =>
    action$.pipe(
      ofType('QUOTE_ACKED'),
      filter(x => x.workspace === 'dynamic' && isQuoteTypeWithRegulation(x.quoteType)),
      mergeMap(({ tabId, quoteId }) => {
        const quoteOrTabRemoved$ = quoteOrTabRemoved(action$, tabId, quoteId, state$);
        const pgTimeoutMs = getSgmeConfiguration().pgTimeoutMs;
        return productGovernanceAssessment(streaming).pipe(
          filter(x => x.quoteId === quoteId),
          mergeMap(lightEvent =>
            fatEventApiConnector(oldHttpClient)
              .getFatEvent<ProductGovernance>(lightEvent)
              .pipe(
                catchError(_ => EMPTY),
                map(pgAss => productGovernanceAssessmentReceived('dynamic', tabId, quoteId, pgAss)),
              ),
          ),
          take(1),
          takeUntil(quoteOrTabRemoved$),
          timeoutWith(pgTimeoutMs, of(productGovernanceAssessmentTimeout('dynamic', tabId, quoteId)), appScheduler),
        );
      }),
    );
}
